import { useAuthContext } from '@/features/auth/AuthContext';
export var useAuth = function useAuth() {
    var _useAuthContext = useAuthContext(), user = _useAuthContext.user, loading = _useAuthContext.loading, isAuth = _useAuthContext.isAuth, error = _useAuthContext.error, reloadProfile = _useAuthContext.reloadProfile;
    return {
        user: user,
        loading: loading,
        isAuth: isAuth,
        error: error,
        reloadProfile: reloadProfile
    };
};
export var useLogin = function useLogin() {
    var _useAuthContext2 = useAuthContext(), login = _useAuthContext2.login, loading = _useAuthContext2.loading, error = _useAuthContext2.error;
    return {
        login: login,
        loading: loading,
        error: error
    };
};
export var useLogout = function useLogout() {
    var _useAuthContext3 = useAuthContext(), logout = _useAuthContext3.logout, loading = _useAuthContext3.loading, error = _useAuthContext3.error;
    return {
        logout: logout,
        loading: loading,
        error: error
    };
};
export var useRegister = function useRegister() {
    var _useAuthContext4 = useAuthContext(), register = _useAuthContext4.register, loading = _useAuthContext4.loading, error = _useAuthContext4.error;
    return {
        register: register,
        loading: loading,
        error: error
    };
};
